module.exports = require("new-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/recursive-module/index.js
 ** module id = 8
 ** module chunks = 0
 **/